import * as Sentry from '@sentry/browser';
import { Component } from 'react';
import logToDataDog from '../../../config/logToDataDog';

/**
 * @param {string} componentName
 * @param {function(): void} onFailure
 * @returns {JSX.Element}
 * @constructor
 */
export default class LazyErrorBoundary extends Component {
    state = {};

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        this.props.onFailure(error);

        logToDataDog({
            name: 'booking-web-app.lazy.error',
            type: 'increment',
            value: 1,
            tags: [`componentName:${this.props.componentName}`],
        });
        if (typeof window !== 'undefined') {
            const { SENTRY_DSN } = window && window.ZD ? window.ZD.configs : {};
            if (SENTRY_DSN) {
                Sentry.withScope((scope) => {
                    scope.setExtras({
                        info,
                        componentName: this.props.componentName,
                    });
                    Sentry.captureException(error);
                });
            }
        }
    }

    render() {
        if (!this.state.error) {
            return this.props.children;
        }

        return null;
    }
}
